import React from 'react';

const About: React.FC = () => {
  const values = [
    {
      title: 'Quality',
      description: 'We maintain the highest standards in every project, ensuring robust, scalable, and maintainable solutions.',
    },
    {
      title: 'Reliability',
      description: 'Our clients trust us to deliver on time and on budget, with ongoing support and maintenance.',
    },
    {
      title: 'Security',
      description: 'We prioritize data protection and cybersecurity in all our solutions and recommendations.',
    },
    {
      title: 'Partnership',
      description: 'We build long-term relationships with our clients, becoming their trusted technology advisors.',
    },
  ];

  return (
    <section id="about" className="py-20 bg-surface-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-ink-900">
            About 3B Consulting
          </h2>
          <p className="text-lg text-ink-500 max-w-2xl mx-auto">
            Our mission is to empower businesses through innovative technology solutions
          </p>
        </div>
        
        <div className="space-y-16">
          {/* Mission Statement */}
          <div className="glass-card p-8 text-center">
            <h3 className="text-2xl font-semibold mb-6 text-ink-900">
              Our Mission
            </h3>
            <p className="text-lg text-ink-500 leading-relaxed max-w-4xl mx-auto">
              We believe technology should be an enabler, not a barrier. Our team of experts works closely with clients to understand their unique challenges and deliver tailored solutions that drive measurable results.
            </p>
          </div>
          
          {/* Core Values */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <h4 className="text-xl font-semibold mb-4 text-brand-start">
                  {value.title}
                </h4>
                <p className="text-ink-500 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 